import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import Header from '../Header';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import { useMediaQuery } from 'react-responsive';
import BackwardButton from '../../../Button/components/BackwardButton/BackwardButton';
const FullscreenModalHeader = ({ className, title, onClickBackward, onClose }) => {
    const { FullscreenModalHeader: css } = useTheme('BaseComponents');
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const showBackwardButton = Boolean(isMobile && onClickBackward);
    const titleRender = () => (React.createElement("div", { className: css.title__wrapper },
        showBackwardButton && React.createElement(BackwardButton, { variant: "icon", onClick: onClickBackward }),
        React.createElement("span", { className: css.title }, title)));
    return (React.createElement(Header, { showEmptySlots: false, left: titleRender(), onClose: onClose, className: cn(css.header, className) }));
};
export default FullscreenModalHeader;
